import * as React from "react";
import {HorizontalScale, VerticalScale} from "./ChartOptions";
import { Switch } from "./Switch";

interface AxesSelectorProps {
    verticalScale: VerticalScale,
    horizontalScale: HorizontalScale,
    changeVerticalScale: (v: VerticalScale) => void,
    changeHorizontalScale: (h: HorizontalScale) => void,
}

export function AxesSelector(props: AxesSelectorProps): React.ReactElement {
    return (<div className="AxesSelector">
        <label>Vertical axis: </label>
        <Switch
            leftLabel="log"
            leftValue={VerticalScale.dB}
            rightLabel="linear"
            rightValue={VerticalScale.amplitude}
            value={props.verticalScale}
            onChange={(_event: React.MouseEvent | React.KeyboardEvent, newValue: VerticalScale) => {
                props.changeVerticalScale(newValue);
            }}
        /><br />
        <label>Horizontal axis: </label>
        <Switch
            leftLabel="harmonics"
            rightLabel="pitch"
            leftValue={HorizontalScale.harmonics}
            rightValue={HorizontalScale.octaves}
            value={props.horizontalScale}
            onChange={(_event: React.MouseEvent | React.KeyboardEvent, newValue: HorizontalScale) => {
                props.changeHorizontalScale(newValue);
            }}
        />
    </div>);
}